import axios from "axios";

// A mock function to mimic making an async request for data
export function fetchUserProfile() {
  return new Promise(async (resolve, reject) => {
      const token = localStorage.getItem('token') || "";
     
      const response = await axios.post(process.env.REACT_APP_BASE_API + "/users/get-profile", {token : token});
      const data = response.data;
      resolve({ data });
  
    
  });
}
export function checkPhoneNo(phoneNo) {
  return new Promise(async (resolve) => {
    const response = await axios.post(
      process.env.REACT_APP_BASE_API+ "/users/check-phone-no",
      { phoneNo: phoneNo }
    );
    const data = response.data;

    resolve({ data });
  });
}
export function registerUser(userData) {
  return new Promise(async (resolve) => {
    const response = await axios.post(process.env.REACT_APP_BASE_API+"/users/register", {
      userData: userData,
    });
    const data = response.data;

    resolve({ data });
  });
}
export function forgetPassword(userData) {
  return new Promise(async (resolve) => {
    const response = await axios.post(
      process.env.REACT_APP_BASE_API+"/users/forget-password",
      {
        userData: userData,
      }
    );
    const data = response.data;

    resolve({ data });
  });
}
export function loginUser(userData) {
  
  return new Promise(async (resolve) => {
    const response = await axios.post(process.env.REACT_APP_BASE_API+"/users/login", {
      userData: userData,
    }); 

    if(response?.data?.status === 1 && response?.data?.data?.by =='google' ){
      localStorage.setItem('token', response?.data?.data?.token);
           
    }
    
    const data = response.data;

    resolve({ data });
  });
}
export function addDeliveryAddress(id, address) {
  return new Promise(async (resolve) => {
    const response = await axios.post(
      process.env.REACT_APP_BASE_API+"/users/add-delivery-address",
      {
        user_id: id,
        address: address,
      }
    );
    const data = response.data;

    resolve({ data });
  });
}
export function getDeliveryAddress(id) {
  return new Promise(async (resolve) => {
    const response = await axios.post(
      process.env.REACT_APP_BASE_API+"/users/get-delivery-address",
      {
        user_id: id,
      }
    );
    const data = response.data;

    resolve({ data });
  });
}
export function updateDeliveryAddress(user_id, address_id, updatedAddress) {
  return new Promise(async (resolve) => {
    const response = await axios.post(
      process.env.REACT_APP_BASE_API+"/users/update-delivery-address",
      {
        user_id,
        address_id,
        updatedAddress,
      }
    );
    const data = response.data;

    resolve({ data });
  });
}
export function updateUser({UserData,userId}) {
  return new Promise(async (resolve) => {
    const response = await axios.post(
      process.env.REACT_APP_BASE_API+"/users/update-user",
      {
      fullName: UserData.fullName,
      email: UserData.email,
      // mobileNo: req.body.userData.mobileNo,
      // city: req.body.userData.city,
      state: UserData.state,
      pincode:UserData.pincode
       ,
        userId:userId
      }
    );
    const data = response.data;
    resolve({ data });
  });
}
export function updateSelectedAddress(user_id, address_id) {
  return new Promise(async (resolve) => {
    const response = await axios.post(
      process.env.REACT_APP_BASE_API+"/selectedaddress/add-select-address",
      {
        user_id,
        address_id,
        
      }
    );
    const data = response.data;

    resolve({ data });
  });
}
export function deleteDeliveryAddress(user_id, address_id) {
  return new Promise(async (resolve) => {
    const response = await axios.post(
      process.env.REACT_APP_BASE_API+"/users/delete-delivery-address",
      {
        user_id,
        address_id,
      }
    );
    const data = response.data;

    resolve({ data });
  });
}
export function fetchUser(id) {
  return new Promise(async (resolve) => {
    const response = await axios.get(
      process.env.REACT_APP_BASE_API+ `/users/get-user/${id}`
    );
    const data = response.data;
    resolve({ data });
  });
}
export function fetchSelectedAddress(id) {
  return new Promise(async (resolve) => {
    const response = await axios.get(
      process.env.REACT_APP_BASE_API+`/selectedaddress/get-select-address/${id}`
    );
    const data =  response.data;
       resolve({ data });
  });
}
export function verifyOtp({mobile,otp}) {
  return new Promise(async (resolve) => {
    const response = await axios.post(process.env.REACT_APP_BASE_API+"/users/verify-otp", {
      otp: otp,
      mobile: mobile,
    });
    if(response?.data?.status === 1){
      localStorage.setItem('token', response?.data?.data?.token);
           
    }
    const data = response.data;

    resolve({ data });
  });
}
export function sendOtp(mobile) {
  return new Promise(async (resolve) => {
    const response = await axios.post(process.env.REACT_APP_BASE_API+"/users/send-otp", {
     
      mobile: mobile,
    });
    const data = response.data;

    resolve({ data });
  });
}



